import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const IconCalendar = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#8B5E3C" strokeWidth="2" strokeLinecap="round">
    <rect x="3" y="4" width="18" height="18" rx="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);
const IconUser = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#8B5E3C" strokeWidth="2" strokeLinecap="round">
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
  </svg>
);
const IconMail = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#8B5E3C" strokeWidth="2" strokeLinecap="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const IconPhone = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#8B5E3C" strokeWidth="2" strokeLinecap="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92v2z"/>
  </svg>
);
const IconPin = ({ size = 13, color = "#7A5A3A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
  </svg>
);
const IconCheck = ({ size = 16, color = "#3D6B2E" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const PERSONNES = ["1","2","3","4","5","6","7","8","9","10+"];
const BASE_URL = "https://senutour.com/api";
const getToken = () => localStorage.getItem("token");

export default function ReservationGuide() {
  const location = useLocation();
  const navigate = useNavigate();
  // guide.state attendu : { id, nom, prenom, ville, prixJournee, prixDemiJournee, telephone }
  const guide = location.state || { nom: "Guide", ville: "Dakar" };

  const [step, setStep]       = useState(1);
  const [focused, setFocused] = useState(null);
  const [envoi, setEnvoi]     = useState(false);
  const [erreur, setErreur]   = useState("");
  const [form, setForm]       = useState({
    prenom: "", nom: "", email: "", telephone: "",
    date: "", typePrestation: "journee", personnes: "2", message: "",
  });

  const handle  = e => setForm({ ...form, [e.target.name]: e.target.value });
  const isValid = form.prenom && form.nom && form.email && form.telephone && form.date;

  const prixEstime = form.typePrestation === "journee"
    ? (guide.prixJournee || 0)
    : (guide.prixDemiJournee || 0);

  const confirmerReservation = async () => {
    if (!isValid) return;
    setErreur("");

    if (!getToken()) {
      setErreur("Vous devez être connecté pour réserver un guide.");
      return;
    }
    if (!guide.id) {
      setErreur("Guide introuvable — revenez à la liste et réessayez.");
      return;
    }

    setEnvoi(true);
    try {
      const res = await fetch(`${BASE_URL}/reservations-guide`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          guideId: guide.id,
          nomClient: form.nom,
          prenomClient: form.prenom,
          emailClient: form.email,
          telephoneClient: form.telephone,
          dateVisite: form.date,
          typePrestation: form.typePrestation,
          nbPersonnes: form.personnes === "10+" ? 10 : parseInt(form.personnes),
          total: prixEstime,
          modePaiement: "a_confirmer",
          message: form.message,
        }),
      });
      const data = await res.json();
      if (res.ok) {
        setStep(2);
      } else {
        setErreur(data.message || "Erreur lors de l'envoi de la réservation.");
      }
    } catch (e) {
      setErreur("Erreur serveur. Réessayez dans un instant.");
    } finally {
      setEnvoi(false);
    }
  };

  const inputStyle = (field) => ({
    width: "100%", padding: "13px 14px 13px 42px",
    border: `1.5px solid ${focused === field ? "#C4441A" : "#E8DCC8"}`,
    borderRadius: 8, fontFamily: "'Space Grotesk', sans-serif", fontSize: 14,
    color: "#1C1008", background: "white", outline: "none", transition: "all .25s",
    boxShadow: focused === field ? "0 0 0 3px rgba(196,68,26,.08)" : "none",
  });

  const InputWrap = ({ field, icon, children }) => (
    <div style={{ position: "relative" }}>
      <span style={{ position: "absolute", left: 13, top: "50%", transform: "translateY(-50%)", display: "flex" }}>
        {icon}
      </span>
      {children}
    </div>
  );

  const Label = ({ children }) => (
    <label style={{ display: "block", fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: 1, marginBottom: 7 }}>
      {children}
    </label>
  );

  const formatPrix = (p) => p ? Number(p).toLocaleString("fr-FR") + " F" : "—";

  return (
    <div style={{ fontFamily: "'Fraunces', serif", background: "#FAF5EC", color: "#1C1008", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@400;500;600;700&display=swap');
        * { margin:0; padding:0; box-sizing:border-box; }

        .btn-main {
          width: 100%; padding: 15px; background: #C4441A; color: white;
          border: none; border-radius: 10px;
          font-family: 'Space Grotesk', sans-serif; font-size: 15px; font-weight: 700;
          cursor: pointer; transition: all .3s;
          display: flex; align-items: center; justify-content: center; gap: 8px;
        }
        .btn-main:hover:not(:disabled) { background: #A03614; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(196,68,26,.3); }
        .btn-main:disabled { opacity: .5; cursor: not-allowed; transform: none; }

        .personne-btn {
          padding: 10px 4px; border-radius: 8px; font-size: 13px; font-weight: 700;
          cursor: pointer; transition: all .2s; border: 1.5px solid #E8DCC8;
          font-family: 'Space Grotesk', sans-serif;
        }
        .personne-btn:hover { border-color: #C4441A; color: #C4441A; }

        .formule-btn {
          padding: 14px; border-radius: 10px; font-size: 14px; font-weight: 700;
          cursor: pointer; transition: all .2s; border: 1.5px solid #E8DCC8;
          font-family: 'Space Grotesk', sans-serif; text-align: left;
        }

        @keyframes scaleIn { from { opacity:0; transform:scale(.85); } to { opacity:1; transform:scale(1); } }
        .scale-in { animation: scaleIn .5s ease forwards; }
        @keyframes fadeUp { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }
        .fade-up { animation: fadeUp .5s ease forwards; }

        @media(max-width:900px) { .resa-grid { grid-template-columns: 1fr !important; } }
        @media(max-width:767px) { .form-2col { grid-template-columns: 1fr !important; } }
      `}</style>

      <Navbar transparent={false} />

      {/* ── BREADCRUMB ── */}
      <div style={{ paddingTop: 68, background: "white", borderBottom: "1px solid rgba(28,16,8,.07)" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "14px 5%", display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          {[
            { label: "Accueil", action: () => navigate("/") },
            { label: "Guides",  action: () => navigate("/guides") },
            { label: `${guide.prenom || ""} ${guide.nom}`.trim(), action: null },
          ].map((b, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
              {i > 0 && <span style={{ color: "#B8A898" }}>›</span>}
              {b.action
                ? <button onClick={b.action} style={{ background: "none", border: "none", cursor: "pointer", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#7A5A3A" }}>{b.label}</button>
                : <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#1C1008", fontWeight: 600 }}>{b.label}</span>
              }
            </div>
          ))}
        </div>
      </div>

      <section style={{ padding: "48px 5% 80px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>

          {/* ── ÉTAPE 2 : Confirmation ── */}
          {step === 2 && (
            <div className="scale-in" style={{ textAlign: "center", padding: "60px 20px" }}>
              <div style={{ display: "flex", justifyContent: "center", marginBottom: 28 }}>
                <div style={{ width: 90, height: 90, borderRadius: "50%", background: "rgba(61,107,46,.08)", border: "2px dashed rgba(61,107,46,.3)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <IconCheck size={44} color="#3D6B2E" />
                </div>
              </div>
              <h1 style={{ fontFamily: "'Fraunces',serif", fontSize: "clamp(26px,4vw,42px)", fontWeight: 800, marginBottom: 12, letterSpacing: "-1px" }}>
                Demande envoyée !
              </h1>
              <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 16, color: "#7A5A3A", maxWidth: 480, margin: "0 auto 8px", lineHeight: 1.7 }}>
                Votre demande auprès de <strong>{guide.prenom} {guide.nom}</strong> a été envoyée.
              </p>
              <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "#B8A898", maxWidth: 420, margin: "0 auto 40px" }}>
                Un email de confirmation a été envoyé à <strong style={{ color: "#C4441A" }}>{form.email}</strong>.
              </p>

              <div style={{ background: "white", borderRadius: 16, padding: "24px", maxWidth: 420, margin: "0 auto 32px", border: "1.5px solid rgba(28,16,8,.08)", textAlign: "left" }}>
                {[
                  { icon: "📅", label: "Date",      value: form.date },
                  { icon: "🧭", label: "Formule",   value: form.typePrestation === "journee" ? "Journée complète" : "Demi-journée" },
                  { icon: "👥", label: "Personnes", value: `${form.personnes} personne${form.personnes !== "1" ? "s" : ""}` },
                  { icon: "👤", label: "Nom",       value: `${form.prenom} ${form.nom}` },
                  { icon: "💰", label: "Montant",   value: formatPrix(prixEstime) },
                ].map((r, i) => (
                  <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: i < 4 ? "1px solid rgba(28,16,8,.06)" : "none" }}>
                    <span style={{ fontSize: 18 }}>{r.icon}</span>
                    <div>
                      <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, color: "#7A5A3A", fontWeight: 600, textTransform: "uppercase", letterSpacing: 1 }}>{r.label}</div>
                      <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.value}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
                <button className="btn-main" style={{ maxWidth: 220 }} onClick={() => navigate("/guides")}>
                  ← Retour aux guides
                </button>
                <button onClick={() => navigate("/")} style={{ display: "flex", alignItems: "center", gap: 8, background: "transparent", border: "1.5px solid rgba(28,16,8,.2)", color: "#1C1008", padding: "14px 24px", borderRadius: 10, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
                  Accueil
                </button>
              </div>
            </div>
          )}

          {/* ── ÉTAPE 1 : Formulaire ── */}
          {step === 1 && (
            <div className="resa-grid fade-up" style={{ display: "grid", gridTemplateColumns: "1fr 340px", gap: 32, alignItems: "start" }}>

              {/* ── GAUCHE ── */}
              <div>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 28, fontWeight: 800, marginBottom: 8 }}>
                  Réserver ce guide
                </h2>
                <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "#7A5A3A", marginBottom: 28, lineHeight: 1.6 }}>
                  Complétez vos informations pour envoyer votre demande à <strong style={{ color: "#1C1008" }}>{guide.prenom} {guide.nom}</strong>.
                </p>

                <div style={{ background: "white", borderRadius: 14, padding: "28px", border: "1.5px solid rgba(28,16,8,.06)", marginBottom: 20 }}>
                  <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 18, fontWeight: 700, marginBottom: 22 }}>Vos informations</h3>

                  <div className="form-2col" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
                    <div>
                      <Label>Prénom *</Label>
                      <InputWrap field="prenom" icon={<IconUser />}>
                        <input name="prenom" placeholder="Aminata" value={form.prenom} onChange={handle}
                          onFocus={() => setFocused("prenom")} onBlur={() => setFocused(null)} style={inputStyle("prenom")} />
                      </InputWrap>
                    </div>
                    <div>
                      <Label>Nom *</Label>
                      <InputWrap field="nom" icon={<IconUser />}>
                        <input name="nom" placeholder="Diallo" value={form.nom} onChange={handle}
                          onFocus={() => setFocused("nom")} onBlur={() => setFocused(null)} style={inputStyle("nom")} />
                      </InputWrap>
                    </div>
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <Label>Email *</Label>
                    <InputWrap field="email" icon={<IconMail />}>
                      <input type="email" name="email" placeholder="votre@email.com" value={form.email} onChange={handle}
                        onFocus={() => setFocused("email")} onBlur={() => setFocused(null)} style={inputStyle("email")} />
                    </InputWrap>
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <Label>Téléphone *</Label>
                    <InputWrap field="telephone" icon={<IconPhone />}>
                      <input name="telephone" placeholder="+221 77 000 00 00" value={form.telephone} onChange={handle}
                        onFocus={() => setFocused("telephone")} onBlur={() => setFocused(null)} style={inputStyle("telephone")} />
                    </InputWrap>
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <Label>Date de la visite *</Label>
                    <InputWrap field="date" icon={<IconCalendar />}>
                      <input type="date" name="date" value={form.date} onChange={handle}
                        min={new Date().toISOString().split("T")[0]}
                        onFocus={() => setFocused("date")} onBlur={() => setFocused(null)} style={inputStyle("date")} />
                    </InputWrap>
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <Label>Formule</Label>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                      <button type="button" className="formule-btn"
                        onClick={() => setForm({ ...form, typePrestation: "journee" })}
                        style={{
                          background: form.typePrestation === "journee" ? "#1C1008" : "white",
                          color: form.typePrestation === "journee" ? "white" : "#1C1008",
                          borderColor: form.typePrestation === "journee" ? "#1C1008" : "#E8DCC8",
                        }}>
                        Journée complète<br/>
                        <span style={{ fontWeight: 500, fontSize: 12, opacity: 0.8 }}>{formatPrix(guide.prixJournee)}</span>
                      </button>
                      <button type="button" className="formule-btn"
                        onClick={() => setForm({ ...form, typePrestation: "demi_journee" })}
                        style={{
                          background: form.typePrestation === "demi_journee" ? "#1C1008" : "white",
                          color: form.typePrestation === "demi_journee" ? "white" : "#1C1008",
                          borderColor: form.typePrestation === "demi_journee" ? "#1C1008" : "#E8DCC8",
                        }}>
                        Demi-journée<br/>
                        <span style={{ fontWeight: 500, fontSize: 12, opacity: 0.8 }}>{formatPrix(guide.prixDemiJournee)}</span>
                      </button>
                    </div>
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <Label>Nombre de personnes</Label>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(10, 1fr)", gap: 6 }}>
                      {PERSONNES.map(p => (
                        <button key={p} type="button" className="personne-btn"
                          onClick={() => setForm({ ...form, personnes: p })}
                          style={{
                            background: form.personnes === p ? "#1C1008" : "white",
                            color: form.personnes === p ? "white" : "#7A5A3A",
                            borderColor: form.personnes === p ? "#1C1008" : "#E8DCC8",
                          }}
                        >{p}</button>
                      ))}
                    </div>
                  </div>

                  <div>
                    <Label>Message (optionnel)</Label>
                    <textarea name="message" placeholder="Centres d'intérêt, lieux à visiter en priorité, besoins particuliers..."
                      value={form.message} onChange={handle} rows={3}
                      onFocus={() => setFocused("message")} onBlur={() => setFocused(null)}
                      style={{ ...inputStyle("message"), padding: "13px 16px", resize: "vertical" }}
                    />
                  </div>
                </div>

                {erreur && (
                  <div style={{ background:"rgba(196,68,26,.08)", border:"1.5px solid rgba(196,68,26,.2)", borderRadius:8, padding:"12px 16px", marginBottom:12 }}>
                    <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:13, color:"#C4441A", margin:0 }}>
                      ⚠️ {erreur}
                    </p>
                  </div>
                )}
                <button className="btn-main" disabled={!isValid || envoi} onClick={confirmerReservation}>
                  {envoi ? "Envoi en cours…" : "Envoyer la demande →"}
                </button>
                <button onClick={() => navigate("/guides")}
                  style={{ width: "100%", marginTop: 10, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: "none", border: "1.5px solid rgba(28,16,8,.15)", borderRadius: 10, padding: "12px", cursor: "pointer", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, color: "#7A5A3A" }}>
                  ← Retour aux guides
                </button>
              </div>

              {/* ── DROITE — Récap sticky ── */}
              <div style={{ position: "sticky", top: 88 }}>
                <div style={{ background: "white", borderRadius: 16, overflow: "hidden", border: "1.5px solid rgba(28,16,8,.08)", boxShadow: "0 4px 20px rgba(28,16,8,.08)" }}>
                  <div style={{ background: "#C4441A", padding: "20px 24px" }}>
                    <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, fontWeight: 700, color: "rgba(255,255,255,.7)", textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 }}>Votre réservation</p>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 20, fontWeight: 800, color: "white", marginBottom: 4 }}>{guide.prenom} {guide.nom}</h3>
                    {guide.ville && (
                      <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                        <IconPin size={11} color="rgba(255,255,255,.7)" />
                        <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "rgba(255,255,255,.75)" }}>{guide.ville}</span>
                      </div>
                    )}
                  </div>
                  <div style={{ padding: "20px 24px" }}>
                    {[
                      { icon: "📅", label: "Date",      value: form.date || "—" },
                      { icon: "🧭", label: "Formule",   value: form.typePrestation === "journee" ? "Journée complète" : "Demi-journée" },
                      { icon: "👥", label: "Personnes", value: form.personnes ? `${form.personnes} pers.` : "—" },
                      { icon: "👤", label: "Nom",       value: form.prenom && form.nom ? `${form.prenom} ${form.nom}` : "—" },
                    ].map((r, i) => (
                      <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 0", borderBottom: i < 3 ? "1px solid rgba(28,16,8,.06)" : "none" }}>
                        <span style={{ fontSize: 16 }}>{r.icon}</span>
                        <div>
                          <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, color: "#7A5A3A", fontWeight: 600, textTransform: "uppercase", letterSpacing: 1 }}>{r.label}</div>
                          <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 600, color: r.value === "—" ? "#B8A898" : "#1C1008" }}>{r.value}</div>
                        </div>
                      </div>
                    ))}
                    <div style={{ marginTop: 16, background: "rgba(196,68,26,.05)", borderRadius: 10, padding: "14px" }}>
                      <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, color: "#7A5A3A", fontWeight: 600, textTransform: "uppercase", letterSpacing: 1, marginBottom: 4 }}>Montant estimé</div>
                      <div style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#C4441A" }}>{formatPrix(prixEstime)}</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}